var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb4 col-xs-8 col-sm-4 col-md-3 col-lg-2 center"},[_vm._t("default"),_c('h6',{staticClass:"mt2"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"bodyCopy"},[_vm._v(_vm._s(_vm.description))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }